import React from 'react';
import { 
  EnvelopeIcon, 
  MapPinIcon,
  ShieldCheckIcon,
  ComputerDesktopIcon,
  AcademicCapIcon,
  DocumentTextIcon,
  ClockIcon
} from '@heroicons/react/24/outline';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About Us', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Training', href: '#training' },
    { name: 'Contact', href: '#contact' },
  ];

  const services = [
    { name: 'Security Audits', icon: ShieldCheckIcon, href: '#services' },
    { name: 'Penetration Testing', icon: ComputerDesktopIcon, href: '#services' },
    { name: 'ISO Certification', icon: DocumentTextIcon, href: '#services' },
    { name: 'Training Programs', icon: AcademicCapIcon, href: '#training' },
  ];

  const contactInfo = [
    // { 
    //   icon: PhoneIcon, 
    //   label: 'Phone',
    //   value: '+234 706 492 3306',
    //   href: 'tel:+2347064923306'
    // },
    { 
      icon: EnvelopeIcon, 
      label: 'Email',
      value: 'support@gxtigroup.com',
      href: 'mailto:support@gxtigroup.com'
    },
    { 
      icon: MapPinIcon, 
      label: 'Head Office',
      value: 'Lagos, Nigeria',
      href: 'https://maps.google.com/?q=Lagos,Nigeria'
    },
       { 
      icon: MapPinIcon, 
      label: 'Office',
      value: 'United Kingdom',
      href: 'https://maps.google.com/?q=United+Kingdom'
    },
    { 
      icon: ClockIcon, 
      label: 'Hours',
      value: 'Mon-Fri: 8AM - 6PM',
      href: null
    },
  ];

  // Placeholder URLs for social media - replace with actual URLs
  const socialLinks = [
    {
      name: 'LinkedIn',
      href: 'https://linkedin.com/company/gxt-international', // Replace with actual URL
      icon: (props) => (
        <svg {...props} fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451c.979 0 1.771-.773 1.771-1.729V1.729C24 .774 23.203 0 22.225 0z"/>
        </svg>
      )
    },
    {
      name: 'Twitter',
      href: 'https://twitter.com/gxtinternational', // Replace with actual URL
      icon: (props) => (
        <svg {...props} fill="currentColor" viewBox="0 0 24 24">
          <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.104c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 0021.58-12.582c0-.213-.005-.425-.014-.637.957-.723 1.79-1.58 2.458-2.6z"/>
        </svg>
      )
    },
    {
      name: 'Facebook',
      href: 'https://facebook.com/gxtinternational', // Replace with actual URL
      icon: (props) => (
        <svg {...props} fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      )
    }
  ];

  // Legal links - replace with actual URLs when available
  const legalLinks = [
    { name: 'Privacy Policy', href: '/privacy-policy' },
    { name: 'Terms of Service', href: '/terms-of-service' },
    { name: 'Cookie Policy', href: '/cookie-policy' },
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-950 text-white pt-16 pb-8 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, rgba(255,255,255,0.1) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      {/* Top Border Gradient */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-blue-500 to-transparent"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img 
                src="/gxti-svg.svg" 
                alt="GxT International Logo"
                className="h-12 w-auto invert brightness-0"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Specialized IT Consulting & Capacity Building Firm delivering excellence in Information Security, 
              Assurance, and Project Management.
            </p>
            <div className="flex space-x-4 pt-4">
              {socialLinks.map((social) => (
                <a 
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-all duration-300 transform hover:scale-110 group"
                  aria-label={social.name}
                >
                  <social.icon className="w-5 h-5 text-gray-400 group-hover:text-white" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white relative inline-block">
              Quick Links
              <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-red-500"></span>
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a 
                    href={link.href}
                    className="text-gray-400 hover:text-blue-400 transition-colors duration-300 flex items-center group"
                  >
                    <span className="w-1.5 h-1.5 bg-gray-600 rounded-full mr-2 group-hover:bg-blue-500 transition-all duration-300"></span>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white relative inline-block">
              Our Services
              <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-red-500"></span>
            </h3>
            <ul className="space-y-3">
              {services.map((service, index) => {
                const Icon = service.icon;
                return (
                  <li key={index}>
                    <a 
                      href={service.href}
                      className="text-gray-400 hover:text-blue-400 transition-colors duration-300 flex items-center group"
                    >
                      <Icon className="h-4 w-4 mr-2 text-gray-600 group-hover:text-blue-500 transition-colors duration-300" />
                      {service.name}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white relative inline-block">
              Contact Info
              <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-red-500"></span>
            </h3>
            <ul className="space-y-4">
              {contactInfo.map((item, index) => {
                const Icon = item.icon;
                const content = (
                  <>
                    <Icon className="h-5 w-5 text-blue-400 flex-shrink-0" />
                    <div className="ml-3">
                      <p className="text-xs text-gray-500">{item.label}</p>
                      {item.href ? (
                        <a 
                          href={item.href}
                          className="text-gray-300 hover:text-blue-400 transition-colors duration-300 text-sm"
                        >
                          {item.value}
                        </a>
                      ) : (
                        <p className="text-gray-300 text-sm">{item.value}</p>
                      )}
                    </div>
                  </>
                );

                return item.href ? (
                  <li key={index}>
                    <a 
                      href={item.href}
                      className="flex items-start hover:bg-gray-800/50 p-2 rounded-lg transition-all duration-300 group"
                    >
                      {content}
                    </a>
                  </li>
                ) : (
                  <li key={index} className="flex items-start p-2">
                    {content}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 mt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © {currentYear} GxT International Consulting Limited. All rights reserved.
            </p>
            
            <div className="flex space-x-6">
              {legalLinks.map((link) => (
                <a 
                  key={link.name}
                  href={link.href}
                  className="text-gray-500 hover:text-blue-400 text-sm transition-colors duration-300"
                >
                  {link.name}
                </a>
              ))}
            </div>

            {/* Back to Top Button */}
            <a 
              href="#home" 
              className="bg-gray-800 hover:bg-blue-600 w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300 transform hover:-translate-y-1 group"
              aria-label="Back to top"
            >
              <svg 
                className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors duration-300" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
              </svg>
            </a>
          </div>

          {/* Company Registration Info */}
          <div className="mt-6 text-center md:text-left">
            <p className="text-xs text-gray-600">
              RC: 1234567 | VAT: 12345678-9001 | ISO 27001 Certified Company
            </p>
          </div>
        </div>
      </div>

      {/* Mobile Spacer - prevents content from being hidden behind bottom nav */}
      <div className="h-16 md:hidden"></div>
    </footer>
  );
};

export default Footer;